import React from 'react';
import styles from './LowerSidedrawerOption.module.css';

const LowerSidedrawerOption = props => (
    <div className={ styles.LowerSidedrawerOption }>
        <a href={props.info.urlPath} className={ styles.Label }><p className={ styles.Label }> {props.info[props.language]} </p></a>
    </div>
);

export default LowerSidedrawerOption;